module.exports = __webpack_public_path__ + "static/media/anas.2680c2e9.jpg";